import styled, { createGlobalStyle } from 'styled-components'

export const HistoryArtistsStyle = styled.div`
  .history-artists-grid {
    margin-right: -${props => props.previewGap || 23}px;
    @media (max-width: 700px) {
      margin-right: 0px;
      justify-content: center;
    }
  }
`

export const GlobalStyle = createGlobalStyle`
  .ClosingModal_Overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.70);
    z-index: 10;
  }
  .ClosingModal_Content {
    position: absolute;
    max-height: 299px;
    display: flex;
    justify-content: center;
    width: 880px;
    height: 100%;
    top: calc(50% - 170px);
    left: calc(50vw - 440px);
    background: #fff;
    -webkit-overflow-scrolling: touch;
    border-radius: 10px;
    outline: none;
    text-align: center;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    color: #000;
    @media (max-width: 930px) {
      width: 335px;
      max-height: 330px;
      top: calc(50% - 230px);
      left: calc(50vw - 167px);
    }
    h3 {
      font-family: StolzlMedium, serif;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.5;
      text-transform: uppercase;
    }
    .closeWrapper {
      font-family: StolzlLight, serif;
      max-width: 685px;
      font-size: 16px;
      line-height: 1.88;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 930px) {
        justify-content: flex-end;
      }
    }
    .sureDelete { 
      max-width: 685px;
      margin-bottom: 50px;
      @media (max-width: 930px) {
        max-width: 250px;
        font-size: 14px;
        margin-bottom: 20px;
        letter-spacing: normal;
        line-height: 1.57;
      }
    }
    .modalButtons {
      display: flex;
      @media (max-width: 930px) {
        flex-direction: column;
        margin-bottom: 33px;
      }
    }
    .modalButtons > div {
      :first-child {
        margin-right: 60px;
      }
      @media (max-width: 930px) {
        :first-child {
          margin-right: 0;
        }
      }
      @media (max-width: 700px) {
        :first-child {
          margin-bottom: 10px;
        }
      }
    }
  }
`

export const Container = styled.div`
  flex: 1;
  width: 100vw;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  padding-top: 40px;
  @media (max-width: 1000px) {
    padding-top: 0;
  }
  
  .content {
    display: flex;
    flex-direction: column;
    width: 100vw;
    position: relative;
    .row {
      display: flex;
      flex-direction: row;
      @media (max-width: 650px) {
        flex-direction: column;
      }
    }
    .searchPanelMobile {
      display: none;
      @media (max-width: 650px) {
        display: inherit;
        margin-left: 0px;
        width: 100%;
        margin-top: 15px;
        margin-bottom: 25px;
      }
    }
    .searchPanel {
      position: absolute;
      display: flex;
      top: -125px;
      right: 80px;
      @media (max-width: 1000px) {
        position: relative;
        align-items: center;
        justify-content: center;
        top: 0;
        right: 0;
        margin-bottom: 50px;
      }
      @media (max-width: 650px) {
        display: none;
        position: absolute;
        margin-bottom: 0;
        width: 100%;
        top: 100px;
      }
    }
    .spPlaces {
      @media (max-width: 650px) {
        top: 180px;
      }
    }
    .spArtists {
      @media (max-width: 650px) {
        top: 230px;
      }
    }
  }
  .menu {
    display: flex;
    flex-direction: column;
    margin-right: 70px;
    width: 210px;
    min-width: 180px;
    @media (max-width: 1000px) {
      margin-right: 15px;
    }
    @media (max-width: 650px) {
      margin-bottom: 100px;
    }
  }
  .spMenu {
    @media (max-width: 650px) {
      margin-bottom: 0px;
    }
  }
  .list {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    @media (max-width: 650px) {
      width: calc(100vw - 40px);
    }
  }
  .filters {
    display: flex;
    flex-direction: column;
    margin-left: 0;
  }
  .gridContainer {
    margin-left: -15px;
    @media (max-width: 650px) {
      margin-right: -15px;
    }
  }
  .podcasts-content {
    margin-top: -100px;
    
    h1 {
      margin-bottom: 45px;
    }

    @media (max-width: 650px) {
      margin-top: 0;
      h1 {
        margin-bottom: 20px;
      }
    }
  }
`

export const Heading = styled.h1`
    text-align: center;
    text-transform: uppercase;
    @media (max-width: 650px) {
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 1px;
      text-align: left;
    }
`
export const Heading2 = styled.h2`
    max-width: 90%;
    margin: 0;
    font-family: StolzlMedium;
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #000000;
`
